import React            from "react";
import { Table }        from "react-bootstrap";

function ExtraChargesTable({extraCharges, getTotal}) {
  return (
    <Table className="medicines-confirmed-list">
        <thead>
        <tr className="modal-section-header px-4 py-3 my-6">
            <th width="25%">Name</th>
            <th width="60%">Remarks</th>
            <th className="text-right" width="15%">Price (RM)</th>
        </tr>
        </thead>
        <tbody>
          {extraCharges?.map((item, index) => {
            return (<tr key={`confirm-med-${index}`}>
            <td className="text-left">{item.name}</td>
            <td className="text-left">{item.remarks}</td>
            <td className="text-right text-nowrap">{parseFloat(item.price).toFixed(2)}</td>
            </tr>)
          })}
            <tr className="font-weight-bold">
              <td colSpan="2" className="text-right">Grand Total</td>
              <td className="text-right text-nowrap">RM {getTotal(extraCharges) || '0.00'}</td>
            </tr>
        </tbody>
    </Table>
  );
}

export default ExtraChargesTable;
